import { createI18n } from 'vue-i18n'
import { nextTick } from 'vue'

// Import locale messages
import en from './locales/en.json'
import ar from './locales/ar.json'
import es from './locales/es.json'
import fr from './locales/fr.json'
import de from './locales/de.json'
import zh from './locales/zh.json'

export const SUPPORTED_LOCALES = {
  en: {
    name: 'English',
    nativeName: 'English',
    dir: 'ltr'
  },
  ar: {
    name: 'Arabic',
    nativeName: 'العربية',
    dir: 'rtl'
  },
  es: {
    name: 'Spanish',
    nativeName: 'Español',
    dir: 'ltr'
  },
  fr: {
    name: 'French',
    nativeName: 'Français',
    dir: 'ltr'
  },
  de: {
    name: 'German',
    nativeName: 'Deutsch',
    dir: 'ltr'
  },
  zh: {
    name: 'Chinese',
    nativeName: '中文',
    dir: 'ltr'
  }
}

export const i18n = createI18n({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
  messages: {
    en,
    ar,
    es,
    fr,
    de,
    zh
  },
  numberFormats: {
    en: {
      currency: {
        style: 'currency',
        currency: 'USD'
      }
    },
    ar: {
      currency: {
        style: 'currency',
        currency: 'SAR'
      }
    }
  },
  datetimeFormats: {
    en: {
      short: {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      },
      long: {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        weekday: 'long',
        hour: 'numeric',
        minute: 'numeric'
      }
    },
    ar: {
      short: {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      },
      long: {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        weekday: 'long',
        hour: 'numeric',
        minute: 'numeric'
      }
    }
  }
})

export async function setLocale(locale) {
  const { dir } = SUPPORTED_LOCALES[locale]
  
  // Load locale messages if not loaded
  if (!i18n.global.availableLocales.includes(locale)) {
    const messages = await loadLocaleMessages(locale)
    i18n.global.setLocaleMessage(locale, messages)
  }

  // Update document direction
  document.documentElement.setAttribute('dir', dir)
  document.documentElement.setAttribute('lang', locale)

  // Update locale
  i18n.global.locale = locale
  localStorage.setItem('userLocale', locale)

  // Wait for DOM update
  await nextTick()
}

export function loadSavedLocale() {
  const savedLocale = localStorage.getItem('userLocale')
  if (savedLocale && Object.keys(SUPPORTED_LOCALES).includes(savedLocale)) {
    setLocale(savedLocale)
  }
}

async function loadLocaleMessages(locale) {
  try {
    const module = await import(`./locales/${locale}.json`)
    return module.default
  } catch (error) {
    console.error(`Error loading locale ${locale}:`, error)
    return {}
  }
}